<div class="profile-header-card">
  <div class="avatar-section">
    <div class="avatar">
      <span class="avatar-initials">{{ getInitials() }}</span>
    </div>
  </div>

  <div class="user-info">
    <h1 class="user-name">
      <app-user-name
        [displayName]="user?.displayName ?? user?.resolvedDisplayName ?? user?.username"
        [firstName]="user?.firstName"
        [lastName]="user?.lastName"
        mode="public"
      />
    </h1>
    <div class="user-email-row">
      @if (user?.email) {
        <p class="user-email">
          <app-icon [type]="IconType.MAIL" [size]="14"></app-icon>
          {{ user?.email }}
        </p>
      }
      @if (isOAuthUser) {
        <span class="oauth-badge">
          <app-icon [type]="IconType.SHIELD" [size]="12"></app-icon>
          OAuth-Konto
        </span>
      }
    </div>
  </div>
</div>
